import { debounce } from 'throttle-debounce';

export function triggerCustomEvent(element, eventName, eventData = null){
    var result = $(element).triggerHandler( eventName, eventData );
        
    if ( result === false ){
        return false;
    }
    return true;
}

export function debounceFunc( callback ){
    return debounce( 500, callback, { atBegin: true } );
} 